import {useSelector} from "react-redux";

import {useTranslate} from "./useTranslate";
import {downloadCsv, formatTime} from "../helpers";

export const useDownloadCSV = () => {
    const {players} = useSelector(state => state.player);
    const translates = useTranslate();
    const rows = [
        [
            translates['GRID_COL_NUMBER'],
            translates['GRID_COL_NAME'],
            translates['GRID_COL_TYPE'],
            translates['GRID_COL_IN_GAME'],
            translates['GRID_COL_KPI'],
            translates['GRID_COL_RANK'],
            translates['EVENTS']
        ]
    ];

    players.forEach(player => {
        rows.push([
            player.inGameNumber || 'N/A',
            player.name || 'N/A',
            translates[player.type],
            formatTime(player.inGameTime/1000),
            player.kpi,
            player.rank,
            ...Object.entries(player.events).map(([eventName, value]) => {
                return `${translates[eventName]}: ${value}`
            })
        ])
    })

    return () => {
        downloadCsv('match_result', rows)
    }
}